/* ==========================================================================
   Advanced Collections List — mobile auto-rotate

   The row itself is a CSS scroll-snap container, so swiping works without this
   file. All this adds is the timed advance, which only runs below 750px (above
   that the section is a static grid), pauses while someone is touching or
   hovering the row, and idles while the section is off-screen.
   ========================================================================== */

(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';
  var DEFAULT_RESUME = 6000;

  function CollectionsCarousel(root) {
    this.root = root;
    this.track = root.querySelector('[data-afc-track]');
    if (!this.track) return;

    this.items = Array.prototype.slice.call(this.track.children);
    this.delay = parseInt(root.getAttribute('data-afc-autoplay'), 10) || 0;
    this.resumeDelay = parseInt(root.getAttribute('data-afc-resume'), 10) || DEFAULT_RESUME;
    if (!this.delay || this.items.length < 2) return;

    this.mq = window.matchMedia(MOBILE_QUERY);
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.timer = null;
    this.resumeTimer = null;
    this.onScreen = true;
    this.pointerInside = false;

    this.tick = this.tick.bind(this);
    this.sync = this.sync.bind(this);
    this.hold = this.hold.bind(this);
    this.release = this.release.bind(this);

    if (typeof this.mq.addEventListener === 'function') {
      this.mq.addEventListener('change', this.sync);
    } else if (typeof this.mq.addListener === 'function') {
      this.mq.addListener(this.sync);
    }

    this.track.addEventListener('pointerenter', this.onPointerEnter.bind(this));
    this.track.addEventListener('pointerleave', this.onPointerLeave.bind(this));
    this.track.addEventListener('pointerdown', this.hold, { passive: true });
    this.track.addEventListener('touchend', this.release, { passive: true });
    this.track.addEventListener('focusin', this.hold);
    this.track.addEventListener('focusout', this.release);

    this.observe();
    this.sync();
  }

  /* Don't rotate a section nobody is looking at. */
  CollectionsCarousel.prototype.observe = function () {
    if (typeof window.IntersectionObserver !== 'function') return;
    var self = this;
    this.observer = new window.IntersectionObserver(
      function (entries) {
        self.onScreen = entries[0].isIntersecting;
        self.sync();
      },
      { threshold: 0.2 }
    );
    this.observer.observe(this.root);
  };

  CollectionsCarousel.prototype.shouldRun = function () {
    return this.mq.matches && this.onScreen && !this.pointerInside;
  };

  CollectionsCarousel.prototype.sync = function () {
    if (this.shouldRun()) this.start();
    else this.stop();
  };

  CollectionsCarousel.prototype.start = function () {
    if (this.timer) return;
    this.timer = window.setInterval(this.tick, this.delay);
  };

  CollectionsCarousel.prototype.stop = function () {
    window.clearInterval(this.timer);
    this.timer = null;
  };

  CollectionsCarousel.prototype.hold = function () {
    window.clearTimeout(this.resumeTimer);
    this.stop();
  };

  CollectionsCarousel.prototype.release = function () {
    var self = this;
    window.clearTimeout(this.resumeTimer);
    this.resumeTimer = window.setTimeout(function () {
      self.sync();
    }, this.resumeDelay);
  };

  /* Hover is mouse-only — a tap fires pointerenter with no matching leave,
     which would stop the rotation for good on a phone. */
  CollectionsCarousel.prototype.onPointerEnter = function (event) {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    this.pointerInside = true;
    this.hold();
  };

  CollectionsCarousel.prototype.onPointerLeave = function (event) {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    this.pointerInside = false;
    this.release();
  };

  CollectionsCarousel.prototype.inset = function () {
    var style = window.getComputedStyle(this.track);
    return (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.borderLeftWidth) || 0);
  };

  CollectionsCarousel.prototype.tick = function () {
    if (!this.shouldRun()) {
      this.stop();
      return;
    }

    var track = this.track;
    var maxScroll = track.scrollWidth - track.clientWidth;
    if (maxScroll <= 1) return;

    var target = 0;
    // 1px of slack absorbs sub-pixel scroll positions.
    if (track.scrollLeft < maxScroll - 1) {
      var inset = this.inset();
      var base = track.offsetLeft + inset;
      target = maxScroll;
      for (var i = 0; i < this.items.length; i += 1) {
        var position = this.items[i].offsetLeft - base;
        if (position > track.scrollLeft + 1) {
          target = Math.min(position, maxScroll);
          break;
        }
      }
    }

    if ('scrollBehavior' in document.documentElement.style) {
      track.scrollTo({
        left: target,
        behavior: this.reduceMotion.matches ? 'auto' : 'smooth'
      });
    } else {
      track.scrollLeft = target;
    }
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-afc-autoplay]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.afcCarousel) return;
      root.afcCarousel = new CollectionsCarousel(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
